import React from "react";
import Svg, { G, Rect } from "react-native-svg";

const DashedLine = ({
  axis,
  height,
  width,
  spacing,
  dashHeight,
  dashColor,
  dashWidth = 1,
}) => {
  const dashes = new Array(Math.floor(height || width / spacing) + 1).fill(
    null,
  );
  if (axis === "horizontal") {
    return (
      <Svg height="3" width="100%">
        <G>
          {dashes.map((_, index) => (
            <Rect
              key={index}
              x="0"
              y="2"
              width={dashWidth}
              height={dashHeight}
              fill={dashColor}
              translateX={spacing * index}
            />
          ))}
        </G>
      </Svg>
    );
  } else {
    return (
      <Svg height={height} width="100%">
        <G>
          {dashes.map((_, index) => (
            <Rect
              key={index}
              x="49%"
              y="0"
              width={dashWidth}
              height={dashHeight}
              fill={dashColor}
              translateY={spacing * index}
            />
          ))}
        </G>
      </Svg>
    );
  }
};

export default DashedLine;
